import { type Constructor } from '../types';

interface BaseWithInitAfterBehaviorConstructors {
  initAfterBehaviorConstructors(): void;
}

/**
 * This behavior is for doing any initialization that needs to happen
 * after all other behavior constructors have run. Simply add this class to the
 * top of your behaviors list and it will call initAfterBehaviorConstructors
 * after all constructors have run.
 *
 * For example, if you want to add persistent controls to an object, you need to
 * do that after the ShapePersistentControlBehaviors constructor has
 * initialized the persistentControls property.
 *
 * The problem is that behaviors run their constructors after the object they
 * are extending. So if you want to do something in the constructor of the class
 * that requires a behavior, you can't. The simplest pattern is to have a post
 * constructor method that run.
 */
function InitAfterBehaviorConstructors(
  Base: Constructor<BaseWithInitAfterBehaviorConstructors>
): any {
  return class extends Base {
    constructor(...args: any[]) {
      super(...args);

      this.initAfterBehaviorConstructors();
    }
  };
}

export default InitAfterBehaviorConstructors;
